import {
  faPlus,
  faSave,
  faTrashAlt,
} from '@fortawesome/pro-regular-svg-icons';
import swal from '@sweetalert/with-react';
import React, { Component } from 'react';
import reqwest from 'reqwest';
import settings from '../../../../../settings';
import Button from '../../../../components/Button';
import ContentBox from '../../../../components/FormArea/ContentBox';
import Dropdown from '../../../../components/Inputs/Dropdown';
import Input from '../../../../components/Inputs/Input';
import Switch from '../../../../components/Inputs/Switch';
import Loader from '../../../../components/Loader';

/**
 * Pflege der Textbausteine durch den Kunden (CARE-803). Bisher war jeder neue
 * Baustein ein Entwicklungsauftrag für eine Textzeile.
 *
 * Der Text wandert beim Schalten im Formular in den Vorgang und bleibt dort
 * stehen. Eine Änderung hier wirkt deshalb nur auf neue Vorgänge - ein
 * Nachdruck zeigt weiterhin den damaligen Wortlaut. Das steht so auch in der
 * Oberfläche, weil es sonst niemand erwartet.
 */
const FORM_TYPES = [
  { value: 'a', label: 'A' },
  { value: 'b', label: 'B' },
  { value: 'c', label: 'C' },
  { value: 'd', label: 'D' },
];

const NEW_PREFIX = 'neu:';

class TextBlocks extends Component {
  constructor(props) {
    super(props);

    this.state = {
      formSet: 'AssignTherapyPlace',
      blocks: [],
      loading: true,
      saving: '',
    };
  }

  componentDidMount() {
    this.load();
  }

  load = () => {
    this.setState({ loading: true });

    reqwest({
      method: 'get',
      url: settings.textblocks.getAll,
      contentType: 'json',
      data: { Token: localStorage.getItem('token'), FormSet: this.state.formSet },
    })
      .then((response) => {
        const blocks = JSON.parse(response) || [];
        this.setState({ blocks: blocks.map(this.withoutChanges), loading: false });
      })
      .catch(() => {
        this.setState({ loading: false });
        swal(
          'Fehler',
          'Die Textbausteine konnten nicht geladen werden.',
          'error',
        );
      });
  };

  withoutChanges = (block) => {
    return { ...block, Changed: false };
  };

  add = () => {
    // Der Schlüssel wird zum Platzhalter im Dokument; ohne Vorschlag tippt
    // jeder eine andere Schreibweise.
    const draft = {
      Guid: `${NEW_PREFIX}${Date.now()}`,
      Key: 'TB_',
      Label: '',
      Text: '',
      FormSet: this.state.formSet,
      FormTypes: 'a',
      Ord: this.state.blocks.length,
      Active: true,
      Changed: true,
    };

    this.setState({ blocks: [...this.state.blocks, draft] });
  };

  change = (guid, field, value) => {
    this.setState({
      blocks: this.state.blocks.map((block) => {
        return block.Guid === guid
          ? { ...block, [field]: value, Changed: true }
          : block;
      }),
    });
  };

  toggleFormType = (guid, type) => {
    const block = this.state.blocks.find((entry) => {
      return entry.Guid === guid;
    });
    const selected = (block.FormTypes || '')
      .split(',')
      .map((value) => {
        return value.trim();
      })
      .filter(Boolean);

    const next = selected.includes(type)
      ? selected.filter((value) => {
          return value !== type;
        })
      : [...selected, type];

    this.setFormTypes(guid, next);
  };

  // Die Reihenfolge wird festgeschrieben, damit dieselbe Auswahl nicht je nach
  // Klickfolge als Aenderung gilt.
  setFormTypes = (guid, values) => {
    this.change(guid, 'FormTypes', (values || []).slice().sort().join(','));
  };

  isNew = (block) => {
    return String(block.Guid || '').startsWith(NEW_PREFIX);
  };

  save = (block) => {
    const payload = {
      ...block,
      Guid: this.isNew(block) ? '' : block.Guid,
      Ord: Number(block.Ord) || 0,
    };
    delete payload.Changed;

    this.setState({ saving: block.Guid });

    reqwest({
      method: 'post',
      url: settings.textblocks.save,
      data: {
        Token: localStorage.getItem('token'),
        TextBlock: JSON.stringify(payload),
      },
    })
      .then((response) => {
        const result = JSON.parse(response);
        this.setState({ saving: '' });

        if (result.SaveResult === 'Saved') {
          this.load();
          return;
        }

        // Die Meldung kommt aus der Prüfung des Dienstes und nennt den Grund.
        swal('Nicht gespeichert', result.Reason || 'Unbekannter Grund.', 'error');
      })
      .catch(() => {
        this.setState({ saving: '' });
        swal('Fehler', 'Der Textbaustein konnte nicht gespeichert werden.', 'error');
      });
  };

  remove = async (block) => {
    if (this.isNew(block)) {
      this.setState({
        blocks: this.state.blocks.filter((entry) => {
          return entry.Guid !== block.Guid;
        }),
      });
      return;
    }

    const confirmed = await swal({
      title: 'Textbaustein löschen',
      content: (
        <div>
          <p>
            <b>{block.Key}</b> wird aus der Auswahl entfernt.
          </p>
          <p>
            Bereits geschriebene Vorgänge behalten ihren Text - ein Nachdruck
            ändert sich dadurch nicht. Soll der Baustein nur vorübergehend
            verschwinden, genügt es, ihn auf inaktiv zu setzen.
          </p>
        </div>
      ),
      buttons: ['Abbrechen', 'Löschen'],
      icon: 'warning',
    });

    if (!confirmed) {
      return;
    }

    reqwest({
      method: 'post',
      url: settings.textblocks.remove,
      data: { Token: localStorage.getItem('token'), Guid: block.Guid },
    })
      .then((response) => {
        const result = JSON.parse(response);
        if (result.SaveResult === 'Saved') {
          this.load();
          return;
        }
        swal('Nicht gelöscht', result.Reason || 'Unbekannter Grund.', 'error');
      })
      .catch(() => {
        swal('Fehler', 'Der Textbaustein konnte nicht gelöscht werden.', 'error');
      });
  };

  selectedFormTypes(block) {
    return (block.FormTypes || '')
      .split(',')
      .map((value) => {
        return value.trim();
      })
      .filter(Boolean);
  }

  renderBlock = (block) => {
    const isNew = this.isNew(block);

    return (
      <ContentBox
        key={block.Guid}
        title={isNew ? 'Neuer Textbaustein' : block.Key || 'Textbaustein'}
      >
        <Input
          type="text"
          label="Schlüssel:"
          name={`TextBlock-Key-${block.Guid}`}
          defaultValue={block.Key || ''}
          // Der Schlüssel steht als Platzhalter in der Vorlage. Ihn später zu
          // ändern hiesse, die Vorlage unbemerkt ins Leere laufen zu lassen.
          isDisabled={!isNew}
          info="Steht so als Platzhalter in der Vorlage und lässt sich später nicht mehr ändern."
          validator={[
            {
              required: true,
              error: 'Bitte füllen Sie dieses Feld aus',
            },
          ]}
          onChange={(value) => {
            return this.change(block.Guid, 'Key', value.toUpperCase());
          }}
        />
        <Input
          type="text"
          label="Beschriftung:"
          name={`TextBlock-Label-${block.Guid}`}
          defaultValue={block.Label || ''}
          info="Beschriftung des Schalters im Formular. Bleibt das Feld leer, steht dort der Text selbst."
          validator={[]}
          onChange={(value) => {
            return this.change(block.Guid, 'Label', value);
          }}
        />
        <Input
          type="number"
          label="Reihenfolge:"
          name={`TextBlock-Ord-${block.Guid}`}
          defaultValue={block.Ord}
          validator={[]}
          onChange={(value) => {
            return this.change(block.Guid, 'Ord', value);
          }}
        />
        <Dropdown
          label="Formulare:"
          name={`TextBlock-FormTypes-${block.Guid}`}
          isMulti
          options={FORM_TYPES}
          defaultValue={this.selectedFormTypes(block)}
          placeholder="Formulare auswählen"
          validator={[]}
          getSelected={(values) => {
            return this.setFormTypes(block.Guid, values);
          }}
        />
        <Input
          type="textarea"
          label="Text im Schreiben:"
          name={`TextBlock-Text-${block.Guid}`}
          defaultValue={block.Text || ''}
          fullWidth
          validator={[
            {
              required: true,
              error: 'Bitte füllen Sie dieses Feld aus',
            },
          ]}
          onChange={(value) => {
            return this.change(block.Guid, 'Text', value);
          }}
        />
        <Switch
          label="Aktiv"
          name={`TextBlock-Active-${block.Guid}`}
          style="switch"
          defaultChecked={block.Active !== false}
          description="Nur aktive Bausteine erscheinen im Formular."
          onChange={(checked) => {
            return this.change(block.Guid, 'Active', checked);
          }}
        />
        <div className="Input--fullWidth Buttonbar">
          {block.Changed && (
            <Button
              type="primary"
              icon={faSave}
              loading={this.state.saving === block.Guid}
              disabled={this.state.saving === block.Guid}
              onClick={() => {
                return this.save(block);
              }}
            >
              Speichern
            </Button>
          )}
          <Button
            type="danger"
            outline
            icon={faTrashAlt}
            onClick={() => {
              return this.remove(block);
            }}
          >
            {isNew ? 'Verwerfen' : 'Löschen'}
          </Button>
        </div>
      </ContentBox>
    );
  };

  render() {
    if (this.state.loading) {
      return <Loader />;
    }

    return (
      <div className="Page-Content">
        <div className="Buttonbar">
          <Button type="primary" icon={faPlus} onClick={this.add}>
            Textbaustein hinzufügen
          </Button>
        </div>

        <ContentBox title="Textbausteine">
          <div className="Input--fullWidth">
            <p className="TextBlocks-Note">
              Textbausteine erscheinen im Formular als Schalter. Der gewählte
              Text wird in den Vorgang geschrieben und bleibt dort stehen: eine
              Änderung hier wirkt nur auf neue Vorgänge, ein Nachdruck zeigt
              weiterhin den damaligen Wortlaut.
            </p>
            <p className="TextBlocks-Note">
              Der Schlüssel muss als Platzhalter in der Vorlage stehen, sonst
              wird der Baustein nicht gedruckt. Für formatierten Text (fett,
              Absätze) lautet der Platzhalter in der Vorlage{' '}
              <b>Html:SCHLÜSSEL</b>.
            </p>
            {this.state.blocks.length === 0 && (
              <p className="TextBlocks-Note">
                Es ist noch kein Textbaustein hinterlegt. Die fest eingebauten
                Bausteine erscheinen weiterhin im Formular.
              </p>
            )}
          </div>
        </ContentBox>

        {this.state.blocks.map(this.renderBlock)}
      </div>
    );
  }
}

export default TextBlocks;
